<template>
    <div id="modal">
      <div id="modal-content" class="modal">
        <h1 id="modal-title">{{ name }}</h1>
        <span id="modal-subtitle">{{ subname }}</span>
        <p id="modal-date">{{ date }}</p>
        <h2 id="modal-member">出演メンバー</h2>
        <div>
        <span v-for="(person, index) in cast" :key="index" id="modal-person">
        {{ person }}
        </span>
        </div>
        <button @click="close()">
          閉じる
        </button>
      </div>
      <div id="modal-overlay"></div>
    </div>
</template>

<script>

export default{
    name: "CastModal",
    props: ["cast","name","subname","date"],
    methods: {
      close() {
        this.$emit("close");
      }
    },
}

</script>

<style scoped>
.modal {
  color:#333;
  padding: 10px 20px;
  border: 2px solid #4a4a4a;
  background: #f2f2f2;
  z-index: 2;
  display: block;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
}


#modal-overlay {
  z-index: 1;
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
  background-color: rgba(0, 0, 0, 0.55);
}


#modal-title {
  font-weight: 700;
  margin: 16px 0 0 0;
  font-size: 16pt;
}

#modal-member {
  font-weight: 600;
  margin: 16px 0 8px 0;
  font-size: 13pt;
}

#modal-subtitle {
  color: #4a4a4a;
  font-weight: 400;
  font-size: 11pt;
  margin: 0;
}


#modal-date {
  font-weight: 500;
  margin: 0;
}


#modal-person {
  padding: 5px 10px;
  background-color: #f0f0f0;
  border-radius: 4px;
  white-space: nowrap; /* 各要素が折り返されないように設定 */
}

button {
  background-color: rgba(255, 255, 255, 0.8); 
  color: #333; /* ボタン文字色 */
  margin: 32px 0 16px 0;
  font-size: 12pt;
  padding: 4px 32px; /* パディング */
  border: solid 2px #bebebe;
  border-radius: 5px; /* 角を丸める */
}

@media (max-width: 769px) {
  .modal {
    left: 0%;
    margin: 0 24px;
    transform: translate(0%, -50%);
  }

  #modal-title {
    font-size: 13pt;
  }

  #modal-member {
    font-size: 11pt;
  }

  #modal-person {
    font-size: 11pt;
  }
}

</style>